import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
  ChangeDetectorRef,
  OnChanges,
} from "@angular/core";
import { NzModalService } from "ng-zorro-antd/modal";
import { NzMessageService } from "ng-zorro-antd/message";
import _ from "lodash";
import { NoteV2Component } from "@root/router/component/note-v2/note-v2.component";
import { NoteV2Service } from "@root/router/component/note-v2/note-v2.service";
import { ViewVoucherComponent } from "@root/component/view-voucher/view-voucher.component";
import { OrderV2Service } from "@root/router/order-v2/order-v2.service";
import { WritePermissionGurd } from "@root/util/decorator";
import { TranslateService } from "@root/shared/service/translate.service";

@Component({
  selector: "host-finance-complete-table",
  templateUrl: "./finance-complete-table.component.html",
  styleUrls: ["./finance-complete-table.component.scss"],
})
export class FinanceCompleteTableComponent implements OnInit, OnChanges {
  @Input() orderDetail;
  @Output() refreshModal = new EventEmitter();
  datas = [
    {
      transaction_id: null,
      currency: "CNY",
      type: "",
      action_type: null,
      amount: null,
      payment_method: null,
      action_time: "",
      note: "",
      operator_name: "",
    },
  ];
  real_income;
  refresh = false;
  in_options;
  out_options;
  in_pay_options;
  out_pay_options;

  constructor(
    private modalService: NzModalService,
    private messageService: NzMessageService,
    private orderService: OrderV2Service,
    public changeDetectorRef: ChangeDetectorRef,
    private noteService: NoteV2Service,
    private translateService: TranslateService
  ) {}

  ngOnInit() {
    this.getOptions();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["orderDetail"] && changes["orderDetail"].currentValue) {
      this.format(changes["orderDetail"].currentValue);
    }
  }

  getOptions() {
    this.orderService.gethouseStatusSettingOptions().subscribe((options) => {
      this.in_options = _.cloneDeep(_.get(options, "income_item"));
      this.out_options = _.cloneDeep(_.get(options, "outcome_item"));
      const transaction_item = _.get(options, "transaction_item");
      _.forEach(transaction_item, (item) => {
        this.in_options.push(item);
        this.out_options.push(item);
      });
      this.in_pay_options = _.cloneDeep(_.get(options, "income_method"));
      this.out_pay_options = _.cloneDeep(_.get(options, "outcome_method"));
      const pay_method = _.get(options, "pay_method");
      _.forEach(pay_method, (item) => {
        this.in_pay_options.push(item);
        this.out_pay_options.push(item);
      });
    });
  }
  format(data) {
    this.clearDatas();
    this.datas = _.get(data, "income_and_expenses.list");
    this.real_income = _.get(data, "income_and_expenses.real_income");
  }

  @WritePermissionGurd("reservation_list")
  delete(data) {
    this.modalService.warning({
      nzTitle: this.translateService.syncGet("warning.note.delete_note"),
      nzCancelText: this.translateService.syncGet("word.cancel"),
      nzOkText: this.translateService.syncGet("word.confirm"),
      nzOnOk: () => {
        this.deletedata(data);
      },
    });
  }

  deletedata(data) {
    const params = {
      transaction_id: data.transaction_id,
    };
    this.orderService.deleteTransaction(params).subscribe((res) => {
      if (res.error_code === 0) {
        const successText = this.translateService.syncGet(
          "success.order.delete_note"
        );
        this.messageService.success(successText);
        this.refresh = true;
        this.refreshModal.emit(this.refresh);
        this.clearDatas();
      }
    });
  }

  @WritePermissionGurd("reservation_list")
  edit(id) {
    this.noteService
      .getTransactionDetail({
        id: id,
      })
      .subscribe((res) => {
        if (res.error_code === 0) {
          this.createNoteModal(_.get(res, "data"), id);
        }
      });
  }

  createNoteModal(data, id) {
    // 需要根据order判断是订单记账还是全局记账
    const modalInstance = this.modalService.create({
      nzTitle: this.translateService.syncGet("word.add_note"),
      nzContent: NoteV2Component,
      nzWidth: 900,
      nzFooter: null,
      nzComponentParams: {
        createOrEdit: "edit",
        orderOrWhole: "order",
        data: data,
        id: id,
      },
    });
    modalInstance.afterClose.subscribe((res) => {
      if (res && res.refresh === true) {
        this.refresh = true;
        this.refreshModal.emit(this.refresh);
        this.clearDatas();
      }
    });
  }

  clearDatas() {
    this.datas = [
      {
        transaction_id: null,
        currency: "CNY",
        type: "",
        action_type: null,
        amount: null,
        payment_method: null,
        action_time: "",
        note: "",
        operator_name: "",
      },
    ];
  }

  getTypeName(type) {
    return type === 1
      ? this.translateService.syncGet("word.income")
      : this.translateService.syncGet("word.outcome");
  }

  getInOptionName(method) {
    const item = _.find(this.in_options, { code: method });
    return item && item.item_name;
  }

  getOutOptionName(method) {
    const item = _.find(this.out_options, { code: method });
    return item && item.item_name;
  }

  getInTradeName(method) {
    const item = _.find(this.in_pay_options, { code: method });
    return item && item.method_name;
  }

  getOutTradeName(method) {
    const item = _.find(this.out_pay_options, { code: method });
    return item && item.method_name;
  }

  viewVoucher(list) {
    if (list.length === 0) {
      return;
    }
    this.modalService.create({
      nzTitle: this.translateService.syncGet("word.account_voucher"),
      nzWidth: 715,
      nzFooter: null,
      nzContent: ViewVoucherComponent,
      nzComponentParams: {
        pictureList: list,
      },
    });
  }
}
